import { render, staticRenderFns } from "./copy_data_pendukung_penilaian.vue?vue&type=template&id=5f997b46&"
import script from "./copy_data_pendukung_penilaian.vue?vue&type=script&lang=js&"
export * from "./copy_data_pendukung_penilaian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports